import { Injectable, signal, Signal } from '@angular/core';
import { IWorkshop } from '../../core/interfaces/workshop.interface';
import { IService } from '../../core/interfaces/service.interface';

export interface FormState {
  services: IService[];
  extraComments: string | null;
  workshop: IWorkshop | null | undefined;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone: string | null;
  date: string | null;
  acceptsCommunications: boolean;
  carInfo: { vin?:string,  makeId?: string | null; make?: string | null; modelId?: string | null, modelImage?: string | null, model?: string | null; kilometers?: number | null, licensePlate?: string | null, customModel?: string | null } | null;
}

@Injectable({
  providedIn: 'root'
})
export class FormStateService {
  private formState = signal<FormState>({
    services: [],
    extraComments: null,
    workshop: null,
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    date: null,
    carInfo: null,
    acceptsCommunications: false
  });

  get formStateSignal(): Signal<FormState> {
    return this.formState;
  }

  setServices(services: IService[]) {
    this.formState.update((prev) => ({ ...prev, services }));
  }

  setExtraComments(extraComments: string) {
    this.formState.update((prev) => ({ ...prev, extraComments }));
  }

  setWorkshop(workshop: IWorkshop | null | undefined) {
    this.formState.update((prev) => ({ ...prev, workshop }));
  }

  setFirstName(firstName: string | null) {
    this.formState.update((prev) => ({ ...prev, firstName }));
  }

  setLastName(lastName: string | null) {
    this.formState.update((prev) => ({ ...prev, lastName }));
  }

  setEmail(email: string | null) {
    this.formState.update((prev) => ({ ...prev, email }));
  }

  setPhone(phone: string | null) {
    this.formState.update((prev) => ({ ...prev, phone }));
  }

  setacceptsCommunications(acceptsCommunications: boolean) {
    this.formState.update((prev) => ({ ...prev, acceptsCommunications }));
  }

  setDate(date: string) {
    this.formState.update((prev) => ({ ...prev, date }));
  }

  setCarInfo(carInfo: { makeId?: string | null; make?: string | null; modelId?: string | null; model?: string | null; modelImage?: string | null; kilometers?: number | null, licensePlate?: string | null, customModel?: string | null }) {
    this.formState.update((prev) => ({
      ...prev,
      carInfo: {
        ...prev.carInfo,
        ...carInfo
      }
    }));
  }

  clearForm() {
    this.formState.set({ services: [], workshop: null, acceptsCommunications: false, date: null, carInfo: null, firstName: null, lastName: null, email: null, phone: null, extraComments: null });
  }
}
